import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/modules/shared/services/geral/app.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { environment } from './../../../../../../../src/environments/environment';
import { SignalR } from 'ng2-signalr';
import { BehaviorSubject } from 'rxjs';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FileSaverService } from 'ngx-filesaver';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-assinatura-interna',
  templateUrl: './assinatura-interna.component.html',
  styleUrls: ['./assinatura-interna.component.css']
})
export class AssinaturaInternaComponent implements OnInit {

  constructor(
    public svc: AppService,
    private router: Router,
    private tl: TranslateService,
    private _signalR: SignalR,
    private http: HttpClient,
    private _FileSaverService: FileSaverService
  ) {
    //Carrega as Traduções Gerais da Tela
    this.svc.sbGetTraducaoAuto("geral.mensagens").subscribe((resp) => {
      this.traducao.geral = resp;
    });
  }

  public eventos_processo_selecionado: any[] = [];
  public finalizados: any[];
  public abertos: any[];
  public colsAbertos: any[];
  public colsFinalizados: any[];
  public traducao: any = {
    geral: "",
    tabela: ""
  }
  public celular: string;
  public txtToken: string = "";
  public imgQRCode: string = "";
  public spinAssinatura = true;
  public ulHora = "";
  public spinEle: boolean = false;
  public spinApp: boolean = false;
  public spinDownload: boolean = false;
  public status: string = "Conectando...";
  public contador: string = "";
  public baseFile: string = "";
  public ipAddress: string = "";
  public contadorFlag: boolean = true;
  public identificadores_assinatura: any[];
  public responder_token_model: any = {
    identificadores: [],
    token: ""
  }

  public contratos_pendentes_assinatura_certificado: any[] = [];

  public modelAssinaCertificadoLote: any = {
    DocumentoAut: "",
    id_autorizador_cliente: "",
    Contratos: []
  }

  public sbAbrirModal(event: Event): void {
    try {
      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  };

  public sbAbrirModalAndamento(event: Event, data): void {
    try {
      var id = $(event.target).attr("data-modal");
      this.eventos_processo_selecionado = data;
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  };

  public sbRetornarFiltros(lista: any[], column: string): any {
    var retorno = [];

    if (lista) {
      for (let i = 0; i < lista.length; i++) {
        retorno.push(lista[i][column]);
      }

      retorno = retorno.filter(function (value, index) { return retorno.indexOf(value) == index });

      for (let i = 0; i < retorno.length; i++) {
        retorno[i] = { label: retorno[i], value: retorno[i] }
      }
    }

    return retorno;
  }

  public checkAll(event) {
    this.abertos.forEach((item, index) => {
      this.abertos[index].fl = event.target.checked;
    });
  }

  public contratosAbertos() {
    try {
      this.spinAssinatura = true;
      this.svc.ContratosAbertosPesquisar();
      this.svc.CadastroContratosAbertos().subscribe((resp) => {
        if (resp == false) this.spinAssinatura = false;
        else if (resp != null) {
          this.spinAssinatura = false;
          for (let i = 0; i < resp.assinaturas.length; i++) {
            resp.assinaturas[i].fl = false;
          }
          this.abertos = resp.assinaturas;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  public contratosFinalizados() {
    try {
      this.spinAssinatura = true;
      this.svc.ContratosFinalizadosPesquisar();
      this.svc.CadastroContratosFinalizados().subscribe((resp) => {
        if (resp == false) this.spinAssinatura = false;
        else if (resp != null) {
          this.spinAssinatura = false;
          this.finalizados = resp.assinaturas;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  public getContrato(id_contrato) {
    try {

      //carregarDocumento
      this.svc.ContratoPesquisar(id_contrato);
      this.svc.CadastroContrato().subscribe((resp) => {
        if (resp != null) {
          const byteCharacters = atob(resp.arquivo);
          const byteArrays = [];

          for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
            const slice = byteCharacters.slice(offset, offset + 1024);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }

          const blob = new Blob(byteArrays, { type: resp.tipo_conteudo });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
          // var pdf = window.open('<a>Um Texto <p class="text-danger"> XPTO</p></a>', '_blank');
          // pdf.document.write(`
          // <ngx-extended-pdf-viewer
          //   [base64Src]="${resp.arquivo}"
          //   backgroundColor="#000"
          //   [height]="'90vh'"
          //   [useBrowserLocale]="true" 
          //   [handTool]="false"
          //   [showHandToolButton]="true" 
          //   [showPrintButton]="true" 
          //   [showOpenFileButton]="false"
          //   [showBookmarkButton]="true">
          // </ngx-extended-pdf-viewer>`)
        }
      });
    } catch (e) {
      throw e;
    }
  }

  public getSumario(id_contrato) {
    try {
      //carregarDocumento
      this.svc.ContratoSumarioPesquisar(id_contrato);
      this.svc.CadastroContratoSumario().subscribe((resp) => {
        if (resp != null) {
          const byteCharacters = atob(resp.arquivo);
          const byteArrays = [];

          for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
            const slice = byteCharacters.slice(offset, offset + 1024);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }

          const blob = new Blob(byteArrays, { type: resp.tipo_conteudo });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        }
      });
    } catch (e) {
      throw e;
    }
  }

  public formatarCelular(txtCelular: string): string {
    try {
      var out: string = "";
      txtCelular.split('').forEach((item, index) => {
        if (index < 6 || index >= txtCelular.split('').length - 2 || index == 10) {
          out += item;
        } else {
          out += '*';
        }
      });
      return out;
    } catch (e) {
      throw e;
    }
  }

  public reenviarToken() {
    try {
      this.contadorFlag = true;
      this.spinEle = true;
      this.contador = "";
      this.txtToken = "";
      var contratos = [];
      this.abertos.forEach((item, index) => {
        if (item.fl) {
          contratos.push(item);
        }
      });

      if (contratos.length == 0) {
        this.svc.sbExibirAlerta("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("assinaturas_contratos.mensagens.selecionar_contrato"));
      } else {
        this.svc.enviarToken(contratos[0].arquivo_contrato);
        this.svc.RetornoToken().subscribe((resp) => {
          if (resp != null) {
            this.spinEle = false;
            if (resp != false) {
              var that = this;
              var contador = 29;
              var timer = setInterval(function () {
                that.contador = "Aguarde..." + contador + "s";
                contador--;
                if (contador == 0) {
                  clearInterval(timer);
                  that.contadorFlag = false;
                }
              }, 1000);
            }
          }
        });
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", "Oops...", "Algo deu errado, por favor entre em contato com o Suporte!");
    }
  }

  public enviarToken() {
    try {
      this.identificadores_assinatura = [];
      this.txtToken = "";
      var contratos = [];
      this.abertos.forEach((item, index) => {
        if (item.fl) {
          contratos.push(item);
        }
      });

      if (contratos.length == 0) {
        this.svc.sbExibirAlerta("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("assinaturas_contratos.mensagens.selecionar_contrato"));
      } else {


        if (contratos.length == 1) {
          this.spinEle = true;
          this.svc.enviarToken(contratos[0].arquivo_contrato);
          this.svc.RetornoToken().subscribe((resp) => {
            if (resp == false) this.spinEle = false;
            else if (resp != null) {
              this.spinEle = false;
              this.svc.sbAbrirModal("modalEletronica");
              this.celular = this.formatarCelular(resp.num_celular);

              var that = this;
              var contador = 29;
              var timer = setInterval(function () {
                that.contador = "Aguarde..." + contador + "s";
                contador--;
                if (contador == 0) {
                  clearInterval(timer);
                  that.contadorFlag = false;
                }
              }, 1000);
            }
          });
        }
        else {
          //Chamada assinatura por lote

          contratos.forEach(element => {
            this.identificadores_assinatura.push(element.identificador_assinatura);
          });

          this.spinEle = true;
          this.svc.enviarTokenAssinaturaLote(this.identificadores_assinatura);
          this.svc.RetornoTokenAssinaturaLote().subscribe((resp) => {
            if (resp == false) this.spinEle = false;
            else if (resp != null) {
              this.spinEle = false;
              this.svc.sbAbrirModal("modalEletronica");
              this.celular = this.formatarCelular(resp.num_celular);

              var that = this;
              var contador = 29;
              var timer = setInterval(function () {
                that.contador = "Aguarde..." + contador + "s";
                contador--;
                if (contador == 0) {
                  clearInterval(timer);
                  that.contadorFlag = false;
                }
              }, 1000);
            }
          });
        }



      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public enviarQRcode() {
    try {
      this.txtToken = "";
      this.spinApp = true;
      this.svc.enviarQRCode();
      this.svc.RetornoQRCode().subscribe((resp) => {
        if (resp == false) this.spinApp = true;
        else if (resp != null) {
          this.spinApp = false;
          this.svc.sbAbrirModal("modalAssinaturaAPP");
          this.imgQRCode = "data:" + resp.tipo_conteudo + ";base64," + resp.arquivo;
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public responderToken() {
    try {
      if (this.txtToken != "") {
        var contratos = [];
        this.abertos.forEach((item, index) => {
          if (item.fl) {
            contratos.push(item);
          }
        });
        if (contratos.length == 0) {
          this.svc.sbExibirAlerta("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("assinaturas_contratos.mensagens.selecionar_contrato"));
        } else {


          if (contratos.length == 1) {
            this.spinEle = true;
            this.svc.responderToken(contratos[0].identificador_assinatura, this.txtToken);
            this.svc.TokenRespondido().subscribe({
              next: (resp: any) => {
                if (resp != null) {
                  this.spinEle = false;
                  if (resp.mensagem != undefined) {
                    this.svc.sbExibirAlerta("warning", "Olha...", resp.mensagem);
                  } else {
                    this.svc.sbExibirAlerta("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("assinaturas_contratos.mensagens.contrato_assinado"));
                    this.svc.sbFecharModal("modalEletronica");
                    this.svc.sbFecharModal("modalAssinaturaAPP");
                    this.contratosFinalizados();
                    this.contratosAbertos();
                  }
                }
              },
              error: (error: HttpErrorResponse) => {
                this.spinEle = false;
                this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
              }
            });
          }
          else {
            this.spinEle = true;
            this.responder_token_model.identificadores = [];
            this.responder_token_model.token = ""

            contratos.forEach(element => {
              this.responder_token_model.identificadores.push(element.identificador_assinatura);
            });

            this.responder_token_model.token = this.txtToken;

            this.svc.responderTokenAssinaturaLote(this.responder_token_model);
            this.svc.TokenAssinaturaLoteRespondido().subscribe({
              next: (resp: any) => {
                if (resp != null) {
                  this.spinEle = false;
                  if (resp.mensagem != undefined) {
                    this.svc.sbExibirAlerta("warning", "Olha...", resp.mensagem);
                  } else {
                    this.svc.sbExibirAlerta("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("assinaturas_contratos.mensagens.contrato_assinado"));
                    this.svc.sbFecharModal("modalEletronica");
                    this.svc.sbFecharModal("modalAssinaturaAPP");
                    this.contratosFinalizados();
                    this.contratosAbertos();
                  }
                }
              },
              error: (error: HttpErrorResponse) => {
                this.spinEle = false;
                this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
              }
            });
          }


        }
      } else {
        this.svc.sbExibirNotificacao("error", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("assinaturas_contratos.mensagens.informe_token"));
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public sbCarregarAbertos() {
    this.colsAbertos = [
      { type: 'checkbox', sort: false, filter: true, filter_type: 'multi-select', header: '', field: 'fl', size: '3%', text_align: 'text-right' },
      { type: 'text-duplo', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("assinatura_tabela.cliente"), field: 'nome_cliente', size: '26%', coluna_aux: 'cnpj_cliente', text_align: 'text-left' },
      { type: 'hide', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'cnpj_cliente', size: '0%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("assinatura_tabela.processo"), field: 'nome_tipo_processo', size: '20%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("assinatura_tabela.numero_contrato"), field: 'numero_contrato', size: '13%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("assinatura_tabela.valor_contrato"), field: 'valor_contrato', size: '11%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'data', header: this.tl.instant("assinatura_tabela.data"), field: 'data_inicio_assinatura', size: '11%', text_align: 'text-left' },
      { type: 'dias', sort: true, filter: false, filter_type: 'multi-select', header: this.tl.instant("assinatura_tabela.dias_aberto"), field: 'dias_aberto_assinatura', size: '8%', text_align: 'text-center' },
      { type: 'contrato', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'id_tipo_processo', size: '4%', text_align: 'text-left' },
      { type: 'historico', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'id_tipo_processo', size: '4%', text_align: 'text-left' }
    ];
  }

  public sbCarregarFinalizados() {
    this.colsFinalizados = [
      { type: 'text-duplo', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("finalizados_tabela.cliente"), field: 'nome_cliente', size: '24%', coluna_aux: 'cnpj_cliente', text_align: 'text-left' },
      { type: 'hide', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'cnpj_cliente', size: '0%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("finalizados_tabela.processo"), field: 'nome_tipo_processo', size: '17%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("finalizados_tabela.numero_contrato"), field: 'numero_contrato', size: '10%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("finalizados_tabela.valor_contrato"), field: 'valor_contrato', size: '10%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'data', header: this.tl.instant("finalizados_tabela.data_inicio"), field: 'data_inicio_assinatura', size: '13%', text_align: 'text-left' },
      { type: 'text', sort: true, filter: true, filter_type: 'data', header: this.tl.instant("finalizados_tabela.data_fim"), field: 'data_final_assinatura', size: '13%', text_align: 'text-left' },
      { type: 'status', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("finalizados_tabela.status"), field: 'status_contrato', size: '9%', text_align: 'text-center' },
      { type: 'contrato', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'id_tipo_processo', size: '4%', text_align: 'text-left' },
      { type: 'sumario', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'ind_sumario', size: '4%', text_align: 'text-left' },
      { type: 'historico', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'id_tipo_processo', size: '4%', text_align: 'text-left' }
    ];
  }

  public atualizarTela() {
    try {
      this.contratosFinalizados();
      this.contratosAbertos();
      this.ulHora = new Date().toLocaleTimeString();
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public enviarCertificadoAux(item, arquivo) {
    try {
      let that = this;

      var versao: string = "";
      var jsonAssinador: any = {
        Client: {
          DocumentoCli: item.cnpj_cliente,
          DocumentoAut: this.svc.fnRemoverMascara(environment.nr_cpf_autorizador),
          id_poder_cliente: item.id_poder_cliente,
          id_autorizador_cliente: environment.id_autorizador,
          Thumbprint: ""
        },
        File: {
          Name: null,
          TempFile: null,
          MimeType: null,
          Base64: arquivo,
          TempBase64: null,
          Stamp: {
            Page: null,
            Text: "",
            Image: "",
            Position: {
              llx: null,
              lly: null,
              lrx: null,
              lry: null
            },
            Size: {
              Width: null,
              Height: null
            },
            HideText: false
          },
          QRCode: {
            AccessKey: null
          },
          AttributeCertificate: {
            OID: null,
            Certificate: null,
            issueBy: null,
            ISSUEDTO: null,
            ISSUEDBYCN: null,
            FRIENDLYNAME: null,
            THUMBPRINT: null,
            PUBLICKEY: null,
            SERIALNUMBER: null
          }
        }
      };

      var conx = this._signalR.createConnection();
      conx.enabledLogging = true;

      conx.status.subscribe({
        next: (s) => console.warn(s.name)
      });
      conx.start().then(
        (c) => {
          console.log('Connectado to Signalr Server...');

          this.status = "Conectado";

          conx.invoke('getversion1').then(
            (data) => versao = data,
            (erro) => {
              if (erro.status === 500) {
                Swal.fire({
                  'width': 600,
                  'title': 'Oops...',
                  'text': erro.message,
                  'icon': 'error'
                });
              } else {
                Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
              }
              console.log(erro);
              this.svc.sbFecharModal("modalStatus");
            }
          );

          window.setTimeout(function () {
            that.status = "Assinando...";
            that.svc.sbFecharModal("modalStatus");
            that.svc.sbAbrirModal("modalAssinador");
          }, 500);

          conx.invoke('Assinar', JSON.stringify(jsonAssinador), '{}', environment.empresa, this.ipAddress, item.identificador_assinatura).then(
            (data) => {
              this.svc.sbFecharModal("modalAssinador");
              this.svc.sbAbrirModal("modalStatus");
              this.status = "Assinado";

              window.setTimeout(function () {
                that.status = "Enviando...";
              }, 500);

              if (JSON.parse(data).erro == undefined) {
                this.svc.enviarCertificado(JSON.parse(data));
                this.svc.RetornoCertificado().subscribe((resp) => {
                  if (resp != null) {
                    if (resp != false) {
                      this.status = "Enviado";
                      this.svc.sbFecharModal("modalStatus");
                      this.svc.sbExibirAlerta("success", "Salvo", "Contrato Assinado com Sucesso!");
                      this.contratosFinalizados();
                      this.contratosAbertos();
                    } else {
                      this.svc.sbFecharModal("modalStatus");
                    }
                  }
                });
              } else {
                this.svc.sbFecharModal("modalStatus");
                this.svc.sbFecharModal("modalAssinador");
                this.svc.sbExibirAlerta("error", "Oops...", JSON.parse(data).erro);
              }
            },
            (erro) => {
              if (erro.status === 500) {
                Swal.fire({
                  'width': 600,
                  'title': 'Oops...',
                  'text': erro.message,
                  'icon': 'error'
                });
              } else {
                Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
              }
              this.svc.sbFecharModal("modalStatus");
              console.log(erro);
            }
          );
        },
        (erro) => {
          this.svc.sbFecharModal("modalStatus");
          this.svc.sbFecharModal("modalAssinador");
          this.svc.sbAbrirModal("modalAviso");

          console.log(erro);
        }
      );
    } catch (e) {
      this.svc.sbFecharModal("modalStatus");
      this.svc.sbFecharModal("modalAssinador");
      throw e;
    }
  };


  public enviarCertificadoAuxLote(model) {
    try {
      let that = this;

      var versao: string = "";
      var jsonAssinador: any = {
        Client: {
          DocumentoCli: null,
          DocumentoAut: this.svc.fnRemoverMascara(environment.nr_cpf_autorizador),
          id_poder_cliente: null,
          id_autorizador_cliente: environment.id_autorizador,
          Thumbprint: ""
        },
        File: {
          Name: null,
          TempFile: null,
          MimeType: null,
          Base64: null,
          TempBase64: null,
          Stamp: {
            Page: null,
            Text: "",
            Image: "",
            Position: {
              llx: null,
              lly: null,
              lrx: null,
              lry: null
            },
            Size: {
              Width: null,
              Height: null
            },
            HideText: false
          },
          QRCode: {
            AccessKey: null
          },
          AttributeCertificate: {
            OID: null,
            Certificate: null,
            issueBy: null,
            ISSUEDTO: null,
            ISSUEDBYCN: null,
            FRIENDLYNAME: null,
            THUMBPRINT: null,
            PUBLICKEY: null,
            SERIALNUMBER: null
          }
        },
        url_api_firmas: environment.advFirmasWebApi,
        url_api_certificado: environment.AdvFirmasWebApiCertificate,
        model: model
      };


      var conx = this._signalR.createConnection();
      conx.enabledLogging = true;

      conx.status.subscribe({
        next: (s) => console.warn(s.name)
      });

      conx.start().then(
        (c) => {
          console.log('Connectado to Signalr Server...');

          this.status = "Conectado";

          conx.invoke('getversion1').then(
            (data) => versao = data,
            (erro) => {
              if (erro.status === 500) {
                Swal.fire({
                  'width': 600,
                  'title': 'Oops...',
                  'text': erro.message,
                  'icon': 'error'
                });
              } else {
                Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
              }
              console.log(erro);
              this.svc.sbFecharModal("modalStatus");
            }
          );



          conx.listenForRaw('mensagemAssinatura').subscribe((data: any) => {
            if (data[0] === "iniciando_assinatura") {
              this.svc.sbFecharModal("modalAssinador");
              this.svc.sbAbrirModal("modalStatus");
              that.status = "Assinando...";
            }

          });

          window.setTimeout(function () {
            console.log("Vai abrir modal do Assinador...");
            that.status = "Assinando...";
            that.svc.sbFecharModal("modalStatus");
            that.svc.sbAbrirModal("modalAssinador");
          }, 500);


          conx.invoke('AssinarEmLote', JSON.stringify(jsonAssinador), '{}', environment.empresa, this.ipAddress, false).then(
            (data) => {
              this.svc.sbFecharModal("modalAssinador");
              this.svc.sbAbrirModal("modalStatus");
              that.status = "Assinando...";

              if (JSON.parse(data).erro == undefined) {
                this.status = "Assinado";
                this.svc.sbFecharModal("modalAssinador");
                this.status = "Enviado";
                this.svc.sbFecharModal("modalStatus");
                this.svc.sbExibirAlerta("success", "Salvo", "Contratos Assinados com Sucesso!");
                this.contratosFinalizados();
                this.contratosAbertos();

              } else {
                this.svc.sbFecharModal("modalStatus");
                this.svc.sbFecharModal("modalAssinador");
                this.svc.sbExibirAlerta("error", "Oops...", JSON.parse(data).erro);
              }
            },
            (erro) => {
              if (erro.status === 500) {
                Swal.fire({
                  'width': 600,
                  'title': 'Oops...',
                  'text': erro.message,
                  'icon': 'error'
                });
              } else {
                Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
              }
              this.svc.sbFecharModal("modalStatus");
              console.log(erro);
            }
          ).then((a) => {
            this.svc.sbFecharModal("modalAssinador");
            this.status = "Enviado";

          });
        },
        (erro) => {
          this.svc.sbFecharModal("modalStatus");
          this.svc.sbFecharModal("modalAssinador");
          this.svc.sbAbrirModal("modalAviso");

          console.log(erro);
        }
      );
    } catch (e) {
      this.svc.sbFecharModal("modalStatus");
      this.svc.sbFecharModal("modalAssinador");
      throw e;
    }
  };


  // public enviarCertificado() {
  //   try {
  //     var contratos = [];
  //     this.abertos.forEach((item, index) => {
  //       if (item.fl) {
  //         contratos.push(item);
  //       }
  //     });
  //     if (contratos.length == 0) {
  //       this.svc.sbExibirAlerta("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("assinaturas_contratos.mensagens.selecionar_contrato"));
  //     } else {
  //       this.svc.ContratoPesquisar(contratos[0].arquivo_contrato);
  //       this.svc.CadastroContrato().subscribe((resp) => {
  //         if (resp != null) {
  //           this.svc.sbAbrirModal("modalStatus");
  //           this.enviarCertificadoAux(contratos[0], resp.arquivo);
  //         }
  //       });
  //     }
  //   } catch (e) {
  //     this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
  //   }
  // }


  public enviarCertificado() {
    try {
      this.contratos_pendentes_assinatura_certificado = [];
      var contratos = [];
      this.abertos.forEach((item, index) => {
        if (item.fl) {
          contratos.push(item);
        }
      });

      if (contratos.length == 0) {
        this.svc.sbExibirAlerta("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("assinaturas_contratos.mensagens.selecionar_contrato"));
      } else {

        if (contratos[0].assina_por_grupo) {
          return false;
        }

        if (contratos.length == 1) {
          this.svc.ContratoPesquisar(contratos[0].arquivo_contrato);
          this.svc.CadastroContrato().subscribe((resp) => {
            if (resp != null) {
              this.svc.sbAbrirModal("modalStatus");
              this.enviarCertificadoAux(contratos[0], resp.arquivo);
            }
          });
        }
        else {
          this.modelAssinaCertificadoLote = {
            DocumentoAut: "",
            id_autorizador_cliente: "",
            Contratos: []
          }

          this.modelAssinaCertificadoLote.DocumentoAut = this.svc.fnRemoverMascara(environment.nr_cpf_autorizador);
          this.modelAssinaCertificadoLote.id_autorizador_cliente = environment.id_autorizador;

          contratos.forEach(contrato => {
            this.modelAssinaCertificadoLote.Contratos.push({ id_poder_cliente: contrato.id_poder_cliente, cnpj_cliente: contrato.cnpj_cliente, arquivo_contrato: contrato.arquivo_contrato, chave: contrato.identificador_assinatura });
          });
          this.enviarCertificadoAuxLote(this.modelAssinaCertificadoLote);

        }
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }
  
  public getIPAddress() {
    var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
    this.http.get("https://api64.ipify.org?format=json", { headers: headers }).subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  public avancarModal() {
    try {
      this.svc.sbFecharModal('modalAviso');
      this.svc.sbAbrirModal('modalAviso2');
      this.downloadFile();
    } catch (e) {
      this.svc.sbExibirAlerta("error", "Oops...", "Algo deu errado, por favor entre em contato com o Suporte!");
    }
  }

  public criarArquivo() {
    try {
      var byteCharacters = atob(this.baseFile);
      var byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        var slice = byteCharacters.slice(offset, offset + 1024);
        var byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: "application/octet-stream" });
      this._FileSaverService.save(blob, 'I@gree Assinador.exe');
    } catch (e) {
      throw e;
    }
  }

  public downloadFile() {
    try {
      if (this.baseFile != "") {
        this.criarArquivo();
      } else {
        this.spinDownload = true;
        this.svc.obterFile(environment.AdvFirmasWebApiCertificate + "AssinarCertificado/DownloadInstalador/" + environment.empresa);
        this.svc.RetornoFileDownload().subscribe((resp) => {
          if (resp != null) {
            this.spinDownload = false;
            if (resp != false) {
              this.baseFile = resp.instalador;
              this.criarArquivo();
            }
          }
        });
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", "Oops...", "Algo deu errado, por favor entre em contato com o Suporte!");
    }
  }

  ngOnInit() {
    try {
      this.ulHora = new Date().toLocaleTimeString();
      this.contratosFinalizados();
      this.contratosAbertos();

      this.svc.sbGetTraducaoAuto("assinatura_tabela").subscribe((resp) => {
        this.sbCarregarAbertos();
      });

      this.svc.sbGetTraducaoAuto("finalizados_tabela").subscribe((resp) => {
        this.sbCarregarFinalizados();
      });

      this.getIPAddress();
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

}
